/**
 * Dismiss floating UI when pointer goes outside `rootRef` (capture phase).
 */

import { type RefObject, useEffect } from 'react';

export function useDismissOnOutsidePointer(
  rootRef: RefObject<HTMLElement | null>,
  open: boolean,
  onDismiss: () => void,
): void {
  useEffect(() => {
    if (!open) return;
    const listener = (e: PointerEvent) => {
      const root = rootRef.current;
      if (root && !root.contains(e.target as Node)) onDismiss();
    };
    document.addEventListener('pointerdown', listener, true);
    return () => document.removeEventListener('pointerdown', listener, true);
  }, [open, onDismiss, rootRef]);
}
